const $ = require('jquery');
import run from '../../../utilities/run';
import render from "../../../utilities/render";
import {handleDisplayFor} from "../../../utilities/selectorHelpers";

// const targetSelector = "#p_p_id_rmsui_WAR_rmsuiportlet_";
const targetSelector = "#replace-with-your-unique-selector";

 // For quick dev prototyping
run(targetSelector, (outerEl)=>{
  attachPages(outerEl);
});

function attachPages(outerEl){


}



// WEBPACK FOOTER //
// ./src/pages/merchantConfig/merchantConfigView/merchantConfigView.js